<template>
	<div id="fullscreen-loading-indicator">
		<div class="loading-container">
			<inline-loading-indicator color="#FFF"></inline-loading-indicator>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import InlineLoadingIndicator from "@/components/InlineLoadingIndicator.vue";

	export default defineComponent({
		components: {
			InlineLoadingIndicator,
		},
	});
</script>

<style lang="stylus" scoped>
	@import '../styles/colors.styl';

	#fullscreen-loading-indicator {
		background: primaryColor;
		min-height: 100vh;

        display: flex;
        justify-content: center;
        flex-direction: column;
	}
</style>